/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type ModificationReasonA85Enum =
  (typeof ModificationReasonA85Enum)[keyof typeof ModificationReasonA85Enum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ModificationReasonA85Enum = {
  not_needed: 'not_needed',
  need_to_modify: 'need_to_modify',
  sitter_requesting_change: 'sitter_requesting_change',
  not_a_good_fit: 'not_a_good_fit',
  extenuating_circumstance: 'extenuating_circumstance',
  feeling_unsafe: 'feeling_unsafe',
  availability_changed: 'availability_changed',
  owner_requesting_change: 'owner_requesting_change',
} as const;
